module.exports = __webpack_public_path__ + "static/media/rhodes_0009_torquelogistics.bc965b9d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rhodes_0009_torquelogistics.jpg
// module id = 170
// module chunks = 0